export default {
  cppAuth: 'https://www.cppdirect.co.uk/members/account',
  experian: 'https://experian.co.uk',
};
